import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { fetchFaqs, updateFaq } from "store/faqSlice";
import { useHistory, useParams } from "react-router-dom";


export default function FaqEdit({ color }) {
const dispatch = useDispatch();
const history = useHistory();
const { id } = useParams();


const { items: faqs } = useSelector((state) => state.faqs);


const [question, setQuestion] = useState("");
const [answer, setAnswer] = useState("");
const [isActive, setIsActive] = useState(true);


useEffect(() => {
    if (!faqs.length) dispatch(fetchFaqs());
}, [dispatch, faqs.length]);


useEffect(() => {
const faq = faqs.find((f) => String(f.id) === String(id));
if (faq) {
setQuestion(faq.question);
setAnswer(faq.answer);
setIsActive(faq.is_active);
}
}, [faqs, id]);


const handleSubmit = (e) => {
e.preventDefault();


dispatch(updateFaq({
id,
data: { question, answer, is_active: isActive },
})).then(() => history.push("/admin/faq"));
};


return (
<div
className={
"relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
(color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
}
>
<div className="max-w-4xl mx-auto p-6 bg-white shadow rounded">
<h2 className="text-xl font-semibold mb-4">Edit FAQ</h2>


<form onSubmit={handleSubmit} className="space-y-4">
<div>
<label className="block text-sm font-medium mb-1">Question</label>
<input
type="text"
className="w-full border px-3 py-2 rounded"
value={question}
onChange={(e) => setQuestion(e.target.value)}
required
/>
</div>


<div>
<label className="block text-sm font-medium mb-1">Answer</label>
<textarea
rows="5"
className="w-full border px-3 py-2 rounded"
value={answer}
onChange={(e) => setAnswer(e.target.value)}
required
/>
</div>
<div className="flex items-center space-x-2">
<input
type="checkbox"
checked={isActive}
onChange={(e) => setIsActive(e.target.checked)}
/>
<label>Is Active</label>
</div>


<div className="flex space-x-2">
<button type="submit" className="bg-lightBlue-600 text-white px-4 py-2 rounded">Update</button>
<button type="button" onClick={() => history.push("/admin/faq")} className="bg-gray-300 px-4 py-2 rounded">Cancel</button>
</div>
</form>
</div>
</div>
);
}
FaqEdit.defaultProps = { color: "light" };
FaqEdit.propTypes = { color: PropTypes.oneOf(["light", "dark"]) };